import { motion } from "framer-motion";
import Reveal, { stagger, fadeUp } from "@/components/Reveal";

const STEPS = [
  {
    step: "01",
    title: "Audit & Discover",
    desc: "We analyse your workflows, database and sales pipeline to spot operational gaps and quick revenue wins.",
  },
  {
    step: "02",
    title: "Connect & Align",
    desc: "We build strategic outreach lists and match your business with the right people and B2B opportunities.",
  },
  {
    step: "03",
    title: "Train & Activate",
    desc: "We deploy sales scripts, launch prospecting calls and coach your team on conversation mastery.",
  },
  {
    step: "04",
    title: "Market & Engage",
    desc: "We run high-impact content and digital campaigns so your brand stays top of mind with target buyers.",
  },
  {
    step: "05",
    title: "Scale & Grow",
    desc: "We monitor performance, refine outreach and turn warm leads into long-term loyal clients.",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-lifecycle-section" className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <Reveal>
            <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 leading-tight">
              How we get your growth sorted
            </h2>
          </Reveal>
          <Reveal>
            <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
              A proven five-step process that takes your business from its current
              baseline to accelerated growth.
            </p>
          </Reveal>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5"
        >
          {STEPS.map((s, i) => (
            <motion.div
              key={s.step}
              variants={fadeUp}
              data-testid={`process-step-${i}`}
              className="relative rounded-2xl border border-slate-200 bg-white p-6 hover:border-emerald-300 hover:shadow-lg hover:shadow-emerald-600/5 transition-all duration-300"
            >
              <span className="font-display text-3xl font-extrabold text-emerald-600/90">{s.step}</span>
              <h3 className="font-display mt-4 text-base font-bold text-slate-900">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              {i < STEPS.length - 1 && (
                <span className="hidden lg:block absolute top-1/2 -right-[13px] w-6 border-t-2 border-dashed border-emerald-200" />
              )}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
